
const addAdditionalFacingRow = (group, bboxModel, countInHeightInt, countInHeightFract, dopusk, sinkH, side) => {
    let lineGroup = group.clone();
    group.clear();
    group.add(lineGroup);

    if (parseFloat(countInHeightInt) > 1) {
        for (let index = 2; index <= countInHeightInt; index++) {
            const newLine = lineGroup.clone();
            newLine.position.y -= (index - 1) * bboxModel.ySize;
            group.add(newLine);
        }
    }

    if (parseFloat(countInHeightFract) > dopusk) {
        const newLine = lineGroup.clone();
        newLine.position.y -= countInHeightInt * bboxModel.ySize;
        newLine.position.y += bboxModel.ySize - bboxModel.ySize * countInHeightFract;
        if (side == 'front') newLine.position.z -= sinkH;
        if (side == 'back') newLine.position.z += sinkH;
        if (side == 'left') newLine.position.x += sinkH;
        if (side == 'right') newLine.position.x -= sinkH;
        group.add(newLine);
    }
    return group;
}
export default addAdditionalFacingRow;
